export const HYDRATABLE_PRODUCT_VENDOR_ID = 'hydratable-product';

export const rawArrayToObject = (rawArray) => {
  if (!Array.isArray(rawArray)) return undefined;
  const entries = rawArray.filter(
    (entry) => entry && entry.id !== null && entry.id !== undefined,
  );
  if (entries.length === 0) return undefined;
  // Null-prototype accumulator: feed-supplied ids like `__proto__`, `toString`,
  // `hasOwnProperty` become regular own data properties instead of mutating the
  // prototype chain or shadowing inherited methods.
  return entries.reduce((acc, { id, value }) => {
    acc[id] = value;
    return acc;
  }, Object.create(null));
};
